import { render } from "./HeaderMain.vue?vue&type=template&id=62491d70&ts=true"
import script from "./HeaderMain.vue?vue&type=script&lang=ts"
export * from "./HeaderMain.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__